/// <amd-module name="Wit/Search/InstantSearchProviders/Services/DisplayWorkItemService" />

import * as React from "react";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { routeUrl } from "VSS/Platform/Location";
import { WorkItemRoute } from "Wit/Search/Constants";

export interface IDisplayWorkItemService extends IVssService {
    displayWorkItem(
        workItemId: string,
        projectName: string,
        openInNewTab?: boolean,
        setHelpVisibility?: (hideHelp: boolean, focusInputOnShow?: boolean) => void,
        callback?: () => void
    ): void;
}

class DisplayWorkItemService extends VssService implements IDisplayWorkItemService {
    public displayWorkItem(
        workItemId: string,
        projectName: string,
        openInNewTab?: boolean,
        setHelpVisibility?: (hideHelp: boolean, focusInputOnShow?: boolean) => void,
        callback?: () => void
    ): void {
        if (openInNewTab) {
            // Open work item in new tab
            const url = routeUrl(
                this.pageContext,
                WorkItemRoute,
                {
                    project: projectName,
                    id: workItemId
                }
            );
            const newWindow = window.open(url, "_blank");
            if (newWindow && newWindow.opener) {
                newWindow.opener = null;
            }
        } else {
            // Open work item dialog over current page
            const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
            if (setHelpVisibility) {
                setHelpVisibility(true);
            }
            layoutManager.renderCallout((onDismiss) => {
                const onWitDialogDismiss = (): void => {
                    onDismiss();
                    if (setHelpVisibility) {
                        setHelpVisibility(false);
                    }
                };

                return React.createElement(LegacyComponent,
                    {
                        modules: ["WorkItemTracking/SharedScripts/WorkItemDialogShim"],
                        wrappedType: "WorkItemDialog",
                        workItemId: Number(workItemId),
                        onDismiss: onWitDialogDismiss
                    });
            });
        }

        if (callback) {
            callback();
        }
    }
}

Services.add("IDisplayWorkItemService", { serviceFactory: DisplayWorkItemService });
